<template>
  <div>
    <div class="view-area">
      <div class="info-area">
        <h3 class="title">AFFILIATED COMPANIES</h3>
        <div class="company">
          <h3 class="name">Cardigan&amp;Co.</h3>
          <p class="contact">&#12306;150-0012 東京都渋谷区広尾1-2-2 萩原ビル5F <br class="isSP">Tel: 03.5475.7006 <br class="isMiddle">Fax: 03.5420.6781</p>
        </div>
        <div class="company">
          <h3 class="name">Hella inc.</h3>
          <p class="contact">&#12306;150-0012 東京都渋谷区広尾1-2-2 萩原ビル7F <br class="isSP">Tel: 03.6450.4411 <br class="isMiddle">Fax: 03.5420.6781</p>
        </div>
      </div>
    </div>
    <Footer />
    <Menu />
  </div>
</template>

<script>
import Footer from './modules/Footer'
import Menu from './modules/Menu'

export default {
  name: 'Affiliate',
  components: {
    Footer,
    Menu
  },
  data () {
    return {
      width: window.innerWidth
    }
  },
  methods: {
    handleResize () {
      this.width = window.innerWidth
    }
  },
  async mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
@supports (-webkit-touch-callout: none) {
  .view-area {
    /* Safari用のハック */
    height: -webkit-fill-available;
  }
}
.view-area {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  letter-spacing: 0.2em;
  padding: 0px 5vw;
}
.info-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 120px;
}
.title {
  margin-bottom: 5vh;
}

.company {
  margin-bottom: 4vh;
}

.company .name {
  margin-bottom: 10px;
}
.company .contact {
  font-size: 11px;
}

.isSP, .isMiddle {
  display: none;
}
@media (max-width: 639px) {
  .view-area {
    padding: 0px 32px;
  }
  .info-area {
    margin-bottom: 60px;
  }
  .isSP{
    display: block;
  }
  .title {
    font-size: 14px;
  }
  .company {
    margin-bottom: 32px;
  }
  .company .name {
    font-size: 14px;
  }
  .company .contact {
    font-size: 11px;
  }
}

@media (max-width: 810px) {
  .isMiddle{
    display: block;
  }
}
@media (max-width: 370px) {
  .info-area {
    margin-bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Affiliate.vue